import { jsxs as e, jsx as r } from "react/jsx-runtime";
import "react";
import f from "../../icons/Facebook.js";
import p from "../../icons/Twitter.js";
import { s as a, S as d } from "../../SocialShareButton-BXGVUD-z.mjs";
import { classes as S } from "../../utils/helpers.js";
function b({
  url: i,
  text: c,
  longtext: t,
  showHeader: l = !1,
  headerText: n = "Share",
  iconSize: s = "1.5rem"
}) {
  const h = [
    { network: "Facebook", icon: f },
    { network: "Twitter", icon: p }
  ];
  return /* @__PURE__ */ e("social-share", { class: a["social-share"], children: [
    l && /* @__PURE__ */ e("h5", { className: "social-share__header", children: [
      n,
      ":"
    ] }),
    h.map((m) => {
      const { network: o, icon: _ } = m;
      return /* @__PURE__ */ r(
        d,
        {
          network: o,
          url: i,
          text: c,
          longtext: t,
          title: `Share on ${o}`,
          children: /* @__PURE__ */ r("i", { className: S(["social-share__icon", a["social-share__icon"], `social-share__icon--${o}`, a[`social-share__icon--${o}`]]), children: /* @__PURE__ */ r(_, { width: s, height: s }) })
        },
        `social-share-${o}`
      );
    })
  ] });
}
export {
  b as SocialShareBlock,
  b as default
};
